import { getAllCatalogsAction, getCatlogsAction } from "@ivymobi/orbit-core/business/productCenter";
import { Box } from "@mui/material"
import { filter, isUndefined } from "lodash";

import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { TenantContext, UserContext } from "../../orbit-context";
import RobotSearch from "./robotSearch";
import ZTree from "./zTree";

export default function PopZtree(props){
    // const { tenant} = useContext(TenantContext);
    // const [onRefresh,setOnRefresh]  = useState(false);
    const [open,setOpen] = useState(false)
    const dispatch = useDispatch();
    const user = useContext(UserContext); 
    const [searchText,setSearchText] = useState('');
    const [showData,setShowData] = useState(null);
    const [result,setResult] = useState(null);
    const [distance,setDistance] = useState(0)

    const setViewState = ()=>{
      setDistance((distance==0)?window.screen.width*0.6:0)
      // if((distance==0)){
      //   onOpen()
      // }else{
      //   onClose()
      // }
      // setOpen(!open);
      
    }
    useEffect(()=>{
    //   RequestAllCatalogs()
    },[])
    const OnItemClick=(item)=>{
      if(item.type==='product'){
        // Taro.navigateTo({
        //   url: './productDetail?id='+item.id+'&name='+base64_encode(encodeURI(item.details?.descriptionShort?.zh))+'&csname='+base64_encode(encodeURI(item.csName)),
        // })
      }else if(item.type==='folder'){
        //   Taro.navigateTo({
        //       url: './newProducts?id='+item.id+'&name='+base64_encode(encodeURI(item.cgName?.zh))+'&csname='+base64_encode(encodeURI(item.csName)),
        //     })
      }
    }
    const OnSearch = (text)=>{
      if(isUndefined(text)|| text.length==0){
        setShowData(result)
        return;
      }
       
    //   Taro.showLoading({ title: 'Loading...' });
      dispatch(getCatlogsAction({user, tenant,nameFilter:text})).then(
        (allProductsInfos) => { 
          // const _allcats = filter(allProductsInfos.catalogs,(item)=>{
          //   console.log("item=",item)
          //   if(item.csName==='PIM DATA MODEL')
          //     return false;
          //   return true;
          // })
        //   Taro.hideLoading();
          setShowData(allProductsInfos.productsData)
          // allProductsInfos.catalogs.map(item=>{ 
          //   if(item.cgName.en==='Product Center'){
          //     dispatch(getCatlogsAction({user, tenant, id:item.id,nameFilter:searchText,shorturl:encodeURI(text)})).then((products)=>{
          //        Taro.hideLoading();
          //        setShowData(products.productsData)
          //     }) 
          //   }
          // })
           
        }
      );
    }

    return <Box  style={{
        display: 'flex', flex: '1',
        position:'absolute',left:-window.screen.width*0.6+'px',top:'0px',width:window.screen.width*0.6+'px',zIndex:distance>0?21:20,
        height: '100%', flexDirection: 'column', backgroundColor: '#f5f5f5',transform:`translate(${distance}px,0px)`,transition:'transform 300ms cubic-bezier(0.36, 0.66, 0.04, 1)'
      }}
      >
        <Box onClick={(e)=>{setViewState();e.stopPropagation();e.preventDefault()}} style={{background:'#aaaaaaaa', position:'absolute',left:0+'px',top:'0px',width:window.screen.width*1.6+'px',zIndex:-1,
        height: '100%',transform:`translate(${distance>0?window.screen.width*0.6:-window.screen.width}px,0px)`,transition:'transform 000ms cubic-bezier(0.36, 0.66, 0.04, 1)'}}>
  
        </Box>
        <Box onClick={()=>{setViewState()}} style={{position:'absolute',right:'-40px',top:'0px',width:'40px',height:'40px',background:'red',display:'flex',justifyContent:'center',alignItems:'center'}}>
          <img src="/images/dr.svg" style={{width:'15px',height:'15px'}}></img >
  
        </Box>
        {/* <SearchView   searchKeyWord={OnSearch} ></SearchView>*/}
        <RobotSearch doSearch={(value)=>{props.setSearchText(value)}}></RobotSearch>

          <ZTree {...props}></ZTree> 
      </Box> 
}